import { createReducer, on } from '@ngrx/store';
import { startsWith } from 'lodash';
import { ApplicationsApiActions, CategoryApplicationViewActions } from './category-applications.actions';
import { adapter, initialState } from './category-applications.state';

export const categoryApplicationsReducer = createReducer(
  initialState,
  on(ApplicationsApiActions.categoryApplicationsLoaded, (state, { applications, categoryType }) => {
    // Clear store for given category
    const toRemoveLoaded = state.ids.map((x) => x.toString()).filter((x) => startsWith(x, categoryType));
    const intermediateStateLoaded = adapter.removeMany(toRemoveLoaded, state);

    // Add applications to store for given category
    return adapter.addMany(applications, intermediateStateLoaded);
  }),
  on(
    CategoryApplicationViewActions.applicationConfigurationsUpdated,
    (state, { categoryType, updatedApplicationsLinkedToCategory }) => {
      // Clear store for given category
      const toRemoveUpdated = state.ids.map((x) => x.toString()).filter((x) => startsWith(x, categoryType));
      const intermediateStateUpdated = adapter.removeMany(toRemoveUpdated, state);

      // Add applications to store for given category
      return adapter.addMany(updatedApplicationsLinkedToCategory, intermediateStateUpdated);
    }
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectCategoryApplicationIds = selectIds;

export const selectCategoryApplicationEntities = selectEntities;

export const selectAllCategoryApplications = selectAll;
